export const DEFAULT_FULLFRAME_ROI = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  mode: 'abs',
  type: 'roi',
  figure: 'rect',
};

export const DRAWING_STATUS = {
  inactive: 'inactive',
  start: 'start',
  drawing: 'drawing',
} as const;

export const POLYGON_PANEL_TEXT_CONTEXT = {
  [DRAWING_STATUS.inactive]: 'edit',
  [DRAWING_STATUS.start]: 'start',
  [DRAWING_STATUS.drawing]: 'draw',
};
